var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	2618: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-behaviors", false, [1,8,20,2], () => (__webpack_require__.e(3747).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-behaviors */ 53747))))))),
	8358: () => (loadStrictSingletonVersion("default", "@azure/msal-browser", false, [4,3,15,0], () => (__webpack_require__.e(1721).then(() => (() => (__webpack_require__(/*! @azure/msal-browser */ 74102))))))),
	12733: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [1,19,2,19], () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	19600: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-stroke", false, [1,14,14,0], () => (__webpack_require__.e(5818).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-stroke */ 25818))))))),
	21302: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-logo", false, [1,14,14,0], () => (__webpack_require__.e(5112).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-logo */ 92731))))))),
	25144: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [1,19,2,19], () => (__webpack_require__.e(8824).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	28458: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-header", false, [1,14,14,0], () => (__webpack_require__.e(4185).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-header */ 4185))))))),
	32648: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-float-menu", false, [1,14,14,0], () => (__webpack_require__.e(3683).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-float-menu */ 16064))))))),
	32778: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (__webpack_require__.e(8219).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	44866: () => (loadStrictSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	62038: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-footer", false, [1,14,14,0], () => (__webpack_require__.e(3343).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-footer */ 3343))))))),
	62420: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-pictogram", false, [1,14,14,0], () => (__webpack_require__.e(2912).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-pictogram */ 22912))))))),
	69192: () => (loadStrictSingletonVersion("default", "@angular/common", false, [1,19,2,19], () => (__webpack_require__.e(7935).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	73184: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-menu-v2", false, [1,14,14,0], () => (__webpack_require__.e(4412).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-menu-v2 */ 34412))))))),
	74592: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-illustration", false, [1,14,14,0], () => (__webpack_require__.e(7924).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-illustration */ 37924))))))),
	81398: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-icon", false, [1,14,14,0], () => (__webpack_require__.e(2781).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-icon */ 82781))))))),
	88390: () => (loadStrictSingletonVersion("default", "@angular/core", false, [1,19,2,19], () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	89556: () => (loadStrictSingletonVersion("default", "@angular/router", false, [1,19,2,19], () => (__webpack_require__.e(2691).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	90080: () => (loadStrictSingletonVersion("default", "@azure/msal-angular", false, [4,3,0,18], () => (__webpack_require__.e(8653).then(() => (() => (__webpack_require__(/*! @azure/msal-angular */ 8653))))))),
	95066: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-avatar", false, [1,14,14,0], () => (__webpack_require__.e(8962).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-avatar */ 36581))))))),
	95930: () => (load("default", "@shared-tokens", false, () => (__webpack_require__.e(2093).then(() => (() => (__webpack_require__(/*! @shared-tokens */ 22093))))))),
	26246: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [1,19,2,19], () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))))),
	60176: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [1,19,2,19], () => (__webpack_require__.e(8070).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	1928: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-tooltip", false, [1,14,14,0], () => (__webpack_require__.e(6564).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-tooltip */ 44183))))))),
	61848: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-helpers", false, [1,14,14,0], () => (__webpack_require__.e(2770).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-helpers */ 90389))))))),
	87656: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-icon-button", false, [1,14,14,0], () => (__webpack_require__.e(1622).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-icon-button */ 1622))))))),
	37328: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-preloader", false, [1,14,14,0], () => (__webpack_require__.e(6468).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-preloader */ 26468))))))),
	52440: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-link", false, [1,14,14,0], () => (__webpack_require__.e(6662).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-link */ 76662))))))),
	89308: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-accordion", false, [1,14,14,0], () => (__webpack_require__.e(3779).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-accordion */ 46160))))))),
	85600: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-badge", false, [1,14,14,0], () => (__webpack_require__.e(8132).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-badge */ 95751))))))),
	66406: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [1,19,2,19], () => (__webpack_require__.e(4456).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"316": [
		44866,
		88390
	],
	"389": [
		88390
	],
	"436": [
		25144,
		69192,
		88390
	],
	"531": [
		88390
	],
	"1034": [
		8358,
		32778,
		44866,
		69192,
		88390,
		89556
	],
	"1622": [
		66406
	],
	"2031": [
		2618,
		61848,
		69192,
		88390,
		89556
	],
	"2075": [
		32778,
		44866,
		69192,
		88390
	],
	"2691": [
		12733,
		32778,
		44866
	],
	"2731": [
		88390
	],
	"2781": [
		61848
	],
	"3343": [
		52440,
		61848,
		89308
	],
	"3437": [
		88390
	],
	"3683": [
		37328,
		61848
	],
	"3779": [
		1928,
		87656
	],
	"4087": [
		69192,
		88390
	],
	"4183": [
		2618,
		69192,
		88390
	],
	"4185": [
		1928,
		61848,
		85600
	],
	"4281": [
		88390
	],
	"4412": [
		61848
	],
	"4456": [
		32778,
		44866
	],
	"4474": [
		88390
	],
	"5072": [
		12733,
		32778,
		44866,
		69192,
		88390
	],
	"5162": [
		61848,
		88390
	],
	"5543": [
		88390
	],
	"5724": [
		2618,
		19600,
		21302,
		52440,
		61848,
		69192,
		81398,
		88390,
		89308,
		89556
	],
	"5751": [
		2618,
		61848,
		69192,
		81398,
		88390,
		95066
	],
	"6064": [
		2618,
		37328,
		61848,
		69192,
		88390
	],
	"6160": [
		1928,
		2618,
		61848,
		69192,
		81398,
		87656,
		88390
	],
	"6443": [
		32778,
		44866,
		88390
	],
	"6566": [
		1928,
		2618,
		21302,
		32648,
		61848,
		69192,
		81398,
		85600,
		88390,
		95066
	],
	"6581": [
		1928,
		2618,
		61848,
		69192,
		88390
	],
	"7580": [
		26246,
		32778,
		44866,
		60176
	],
	"7810": [
		88390
	],
	"7935": [
		44866
	],
	"7959": [
		2618,
		8358,
		12733,
		19600,
		21302,
		25144,
		28458,
		32648,
		32778,
		44866,
		62038,
		62420,
		69192,
		73184,
		74592,
		81398,
		88390,
		89556,
		90080,
		95066,
		95930
	],
	"8055": [
		25144
	],
	"8824": [
		32778,
		44866
	],
	"8962": [
		1928,
		61848
	],
	"9241": [
		66406,
		69192,
		81398,
		88390
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}